<div class="content">
  @if (step === 'get-number') {
    <app-mobile-number (closeDialog)="close($event)"></app-mobile-number>
  }
  @if (step === 'signup-details') {
    <app-main-signup></app-main-signup>
  }
  @if (step === 'login-with-password') {
    <app-mobile-login-with-password
    (closeDialog)="close($event)"></app-mobile-login-with-password>
  }
  @if (step === 'otp-verification') {
    <app-main-otp-verification
      [loginWithPassword]="true"
    (closeDialog)="close($event)"></app-main-otp-verification>
  }
  @if (step === 'signup-otp-verification') {
    <app-main-otp-verification
      [loginWithPassword]="false"
    (closeDialog)="close($event)"></app-main-otp-verification>
  }
  @if (step === 'forgot-password') {
    <app-main-forgot-password></app-main-forgot-password>
  }
  @if (step === 'add-number') {
    <app-main-change-number></app-main-change-number>
  }
  @if (step === 'gmail-mobile-verify') {
    <app-gmail-generate-otp></app-gmail-generate-otp>
  }
</div>
